import { Int }		from "ts-base/numeric/int";

import { Numeric }	from "@v3/data/numeric";

// whole number
export type Integer		= Numeric.Value<typeof Integer>;
export const Integer	= Numeric.fromBase(Int, "must be a whole number");
